import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
// import {
//   // Assuming these thunks exist in your Topics slice
//   fetchAllTopics,
//   fetchTopicTableColumnNames,
//   addTopics,
//   updateTopics,
//   deleteTopics,
//   activateDeactivateTopics,
//   uploadTopicsImageIcon,
//   getTopicPrivilege,
//   addTopicPrivilege,
//   deleteTopicPrivilege,
// } from "../../slices/T"; 
import { getAuthUser } from "../../helpers/utils";
import DeleteModal from "../../Components/Common/DeleteModal";
import CommonTable from "../../Components/Common/Table/CommonTable";
import AddModal from "../../Components/Common/Modal/AddModal";
import AddTopicsModalForm from "../../Components/Common/AddTopicsModalForm/AddTopicsModalForm"; // Ensure this path is correct
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { toast } from "react-toastify";
import { activateDeactivateTopics, fetchAllTopics, fetchTopicTableColumnNames, uploadTopicsImageIcon, addTopics, updateTopics, deleteTopics } from "../../slices/topics/thunk"; 
import ColumnSelectionModal from "../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import { fetchCountry, fetchTranslation, updateUserPreference } from "../../slices/thunks";
import CommonAddModal from "../../Components/Common/Modal/CommonAddModal";
import CommonDataTable from "../../Components/Common/Table/CommonDataTable";
import usePermissions from "../../Components/Hooks/usePermissions";

const labels = [
  // {
  //   id: 1,
  //   labelName: "Classes",
  //   fieldName: "class-drop-down",
  //   name: "GradeID",
  //   value: "GradeID",
  // },
  // {
  //   id: 2,
  //   labelName: "Exam Board",
  //   fieldName: "exam-drop-down",
  //   name: "ExamID",
  //   value: "ExamID",
  // },
  {
    id: 3,
    labelName: "Topic Name English",
    fieldName: "text-box-translate",
    name: "TopicNameEn",
    value: "TopicNameEn",
    required: true,
    translateTo: "TopicNameAr", 
    errorMessage: "Please Enter Topic Name in English",
  },
  {
    id: 4,
    labelName: "Topic Name Arabic",
    fieldName: "text-box",
    name: "TopicNameAr",
    value: "TopicNameAr",
    required: true,
    errorMessage: "Please Enter Topic Name in Arabic",
  },
  // {
  //   id:5,
  //   labelName: "Countries", 
  //   fieldName: "country-drop-down",
  //   name: "CountryIDs", 
  //   value: "CountryIDs", 
  //   required: true 
  // },
  {
    id: 6,
    labelName: "Topic Icon",
    fieldName: "file",
    name: "TopicIcon",
    value: "ImageURL",
    required: true,
    errorMessage: "Please Enter Select Topic Icon",
  },
];

const actionConfig = {
  edit: {
    icon: "ri-edit-2-line",
    tooltip: "Edit",
  },
  delete: {
    icon: "ri-delete-bin-2-line",
    tooltip: "Delete",
  },
};

function TopicMasterTable() { 
  const dispatch = useDispatch();
  const { user } = getAuthUser();
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [lastTranslatedField, setLastTranslatedField] = useState(null);
  

  const { topicsList, loading, headerload, error, topicTableColumnNames, module, uploadedImageUrl, translationLoading} = useSelector((state) => ({
    topicsList: state.Topics.topicsList,  
    loading: state.Topics.loading,
    headerload: state.Topics.headerload,
    error: state.Topics.error,
    topicTableColumnNames: state.Topics.topicTableColumnNames,
    module: state.Module.module, 
    uploadedImageUrl: state.Topics.uploadedImageUrl ,
    country: state.Module.country,
    translationLoading: state.Module.translationLoading, 
  }));


  // Compute permission
  const permission = (() => {
    return usePermissions(3, 11);
  })();

  useEffect(() => {
    dispatch(fetchTopicTableColumnNames({ module: "TOPICS" })); 
    dispatch(fetchAllTopics());
    dispatch(fetchCountry());
  }, [dispatch, user.UserId]);





  const onChangeHandler = (e) => {
    setSelectedRow((preValue) => ({
      ...preValue,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClassesClicks = (value) => {
    setShow(true);
    setIsDisabled(true);
    setIsAddOrEdit(value);
    setSelectedRow({});
  };

  const onEditClickHandler = (topic, value) => {
      setSelectedRow(topic);
      setIsDisabled(false);
      setIsAddOrEdit(value);
      setShow(true);
  }


  // Handler for single delete confirmation
  const handleConfirmSingleDelete = () => {

      dispatch(deleteTopics({ TopicsIDs: selectedIds})).unwrap()
        .then(() => {
          setDeleteModal(null);
        })
    setDeleteModal(false);
  };



   const onSubmitHandler = async (values, { resetForm, setSubmitting }) => {
    setIsDisabled(true); 
    
    try {
      const finalImageUrl = values.TopicIcon; 

      if (!finalImageUrl && labels.find(l => l.name === "TopicIcon" && l.required)) {
          toast.error(t("PleaseUploadTopicIcon"));
          setIsDisabled(false);
          setSubmitting(false);
          return;
      }
      
      const payload = {
        TopicNameEn: values.TopicNameEn,
        TopicNameAr: values.TopicNameAr,
        ImageURL: finalImageUrl, 
      };

      if (isAddOrEdit === 'isEdit') {
        payload.ID = selectedRow.ID;
        dispatch(updateTopics(payload))
      } else {
        dispatch(addTopics(payload))
      }
      
      setShow(false); 
      resetForm();    
    } catch (error) {
      console.error("Topic submission error:", error);
    } finally {
      setIsDisabled(false);
      setSubmitting(false); 
    }
  };

  
  const handleSave = async () => {
    const preferencesPayload = {
      UserId: user.UserId,
      ColumnIDs: topicTableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };

    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(
        fetchTopicTableColumnNames({
          module: "TOPICS",
          roleId: user.RoleId,
          UserId: user.UserId,
        })
      );

      setModalOpen(false);
    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const onTranslateClickHandler = (targetField, textToTranslate, formikSetFieldValue, sourceFieldName) => {
    if (!textToTranslate || textToTranslate.trim() === "") {
      toast.error(t("EnterTextToTranslate"));
      return;
    }
    setLastTranslatedField(sourceFieldName); 

    dispatch(fetchTranslation({ LangText: textToTranslate }))
      .unwrap() 
      .then(translatedText => {
        formikSetFieldValue(targetField, translatedText);
      })
      .catch(error => {
        console.error("Translation error:", error);
        toast.error(t("TranslationFailed"));
      })
      .finally(() => {
        setLastTranslatedField(null); 
      });
  };



  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }


  const onActiveOrDeactiveChange = (topic, e) => {
    if (!permission.CanActive) {
      toast.error(t("NoPermissionToToggle"));
      return;
    }
      const topicObj = {};
      topicObj['ID'] = topic.ID;
      topicObj['IsActive'] = !topic.IsActive;
      topicObj['TableName'] = 'Topics';
      dispatch(activateDeactivateTopics(topicObj))
  }

  const onDeleteClickHandler = topic => {
    if (!permission.CanDelete) {
      toast.error(t("NoPermissionToDelete"));
      return;
    }
    setSelectedIds([topic.ID]);
    setDeleteModal(true);
  }


  return (
    <React.Fragment>
    
      <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("Topics")} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
             <CardHeader>
                <Row className="g-4">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                      {permission.CanAdd && (
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => handleClassesClicks("isAdd")}
                          id="create-btn"
                          disabled={loading}
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      )}
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                        disabled={loading}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row>
            </CardHeader>
              
            <CardBody>
               
              {loading || headerload ? (
                <div className="d-flex justify-content-center align-items-center">
                <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                  Loading...
                </Spinner>
                </div>
              ) : (
                <div className="listjs-table" id="customerList">
                  {/* <CommonTable
                    data={topicsList || []}
                    tableColumnNames={topicTableColumnNames || []}
                    searchTerm={searchTerm}
                    onEditClickHandler={onEditClickHandler}
                    onDeleteClick={onDeleteClickHandler}
                    onActiveOrDeactiveChange={onActiveOrDeactiveChange} 
                    setDeleteModal={setDeleteModal}
                    setSelectedIds={setSelectedIds}
                    permission={permission}
                    keyField="ID"
                  /> */}
                    <CommonDataTable
                      data={topicsList || []}
                      tableColumnNames={topicTableColumnNames || []}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      actionConfig={actionConfig}
                      permission={permission}
                    />
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </Container>  
      </div>      

        {/* Add/Edit Modal  */}
         <CommonAddModal
            show={show}
            setShow={setShow}
            onSubmitHandler={onSubmitHandler}
            labels={labels}
            isAddOrEdit={isAddOrEdit}
            selectedItemData={selectedRow} 
            FormBody={AddTopicsModalForm}
            FormBodyProps={{ 
              onTranslateClickHandler, 
              translationLoading,
              lastTranslatedField,
              setParentSubmitDisabled: setIsDisabled, 
            }}
            title={isAddOrEdit === "isAdd" ? t("Add New Topic") : t("Edit Topic")}
            size="lg" 
            isDisabled={isDisabled} 
          />

        <DeleteModal
          showDelete={deleteModal}
          setShowDelete={setDeleteModal}
          onDeleteClick={handleConfirmSingleDelete}
          setSelectedIds={setSelectedIds} 
          description={"Are you sure you want to delete this record?"}      
        />

        {/* ColumnSelectionModal */}
        <ColumnSelectionModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(!modalOpen)}
          columns={topicTableColumnNames}
          selectedColumns={selectedColumns}
          setSelectedColumns={setSelectedColumns}
          handleSave={handleSave}
        />

    </React.Fragment>
  );
}

export default TopicMasterTable;
